import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { Modal, Button } from 'react-bootstrap';
import { Trans } from "react-i18next";   
import "../../../config/i18n";
import { withTranslation } from "react-i18next";

class PaymentSuccess extends Component {
    render() {
        return (
            <>
                <div className="">
                    <Modal className="modal_div joinplan_modal" show={this.props.showModal} onHide={this.props.handleClose} centered backdrop="static" keyboard={false}>
                        <Modal.Header>
                            <Modal.Title><Trans i18nKey="Cash Payment">Cash Payment</Trans></Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="religion_modal paymentsuccess_modal">
                            <div className=''>
                                <p><Trans i18nKey="Cash request sent successfully to the admin">Cash request sent successfully to the admin</Trans></p>
                            </div>
                        </Modal.Body>
                        <Modal.Footer className="paymentsuccess_okBtn">
                            <Link to="/profile">
                                <Button className='' >
                                    <Trans i18nKey="Ok">Ok</Trans>
                                </Button>
                            </Link>
                        </Modal.Footer>
                    </Modal>
                </div>
            </>
        );
    }
}

export default PaymentSuccess;
